export function clone<T extends Exclude<any, undefined>>(obj: T): T {
  return JSON.parse(JSON.stringify(obj));
}
